export type ComponentTag = (typeof componentTags)[keyof typeof componentTags];

export const componentTags = {
  MARKET_MOVERS: 'MARKET_MOVERS',
  MATCH_CENTRE: 'MATCH_CENTRE',
  ODDS_GRID: 'ODDS_GRID',
  OC_PLUS_TOOLS: 'OC_PLUS_TOOLS',
  POSITIVE_VALUE_BETS: 'POSITIVE_VALUE_BETS',
  PREMIUM_MARKET_MOVERS: 'PREMIUM_MARKET_MOVERS',
  PREMIUM_TIPS: 'PREMIUM_TIPS',
  PREMIUM_TIPSTERS: 'PREMIUM_TIPSTERS',
  PRICE_HISTORY: 'PRICE_HISTORY',
  PUBLIC_BETTING_SPLITS: 'PUBLIC_BETTING_SPLITS',
  TIPS: 'TIPS',
  TRENDS: 'TRENDS',
};
